<template>
  <div>
    <h3 class="mb-2">Withdraw</h3>
    <hr>
    <div class="content">
      <!-- @TODO ADD CONTENT HERE -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'DashboardDeveloper',
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/developer/WithdrawDeveloper.vue